<template>
    <div class="modal" :class="{'backdrop' : backdrop}" id="change-currency" tabindex="-1" role="dialog" aria-labelledby="change-currencyLabel" aria-hidden="true">
        <div class="modal-dialog" :class="[ ($store.getters.window_size.width <= 768) ? 'modal-dialog-centered' : '' ]" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="change-currencyLabel">Change Currency</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <label>Curreny</label>
                    <select class="custom-select shadow-sm" v-model="selectedCurrency" @change="hideModal">
                        <option :value="null" disabled selected>Select a currency</option>
                        <option v-for="currency in currencies" :value="currency.value">{{ currency.name }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
	.backdrop {
		background: rgb(34, 40, 50);
	}
</style>

<script>
	export default {
		data() {
			return {
				selectedCurrency: this.currency ? this.currency : null,
				currencies: this.$store.getters.currencies()
			};
		},
		watch: {
			selectedCurrency: function(currency) {
				this.$emit("change-currency", currency);
			}
		},
		methods: {
			hideModal() {
				$("#change-currency").modal("hide");
			}
		},
		props: ["currency", "backdrop"]
	};
</script>
